import isNil from 'lodash/isNil';
import { isOnline } from '../../../utils/ConnectionStatusUtils';
import Terminal from '../../../shared/entities/terminal';
import { TerminalListItem } from '../../../store';

export const connectivitySortFunction = (a: Terminal | TerminalListItem, b: Terminal | TerminalListItem) => {
  if (a.connectivityStatus === b.connectivityStatus && a.terminalDisplayName && b.terminalDisplayName) {
    return a.terminalDisplayName > b.terminalDisplayName ? 1 : -1;
  } else {
    return isOnline(a.connectivityStatus) ? -1 : 1;
  }
};

export const connectivitySortFunctionForSerialNumber = (a: Terminal | TerminalListItem, b: Terminal | TerminalListItem) => {
  if (a.connectivityStatus === b.connectivityStatus && a.aircraftSerialNumber && b.aircraftSerialNumber) {
    return a.aircraftSerialNumber > b.aircraftSerialNumber ? 1 : -1;
  } else {
    return isOnline(a.connectivityStatus) ? -1 : 1;
  }
};

export const defaultSortFunction = (sortField: string) => {
  return (a: any, b: any) => {
    let sortResult = 0; 
    if (!isNil(sortField)) {
      if (isNil(a[sortField]) && isNil(b[sortField])) {
        sortResult = 0;
      } else if (isNil(a[sortField])) {
        sortResult = -1;
      } else if (isNil(b[sortField])) {
        sortResult = 1;
      } else if (a[sortField] < b[sortField]) {
        sortResult = -1;
      } else if (a[sortField] > b[sortField]) {
        sortResult = 1;
      }
    }

    return sortResult;
  };
};
